import React from "react";
import { ArrowDownTrayIcon, DocumentTextIcon, MicrophoneIcon, UsersIcon } from '@heroicons/react/24/outline';
import memberShipApplication from '../data/membership_application.docx';
import memberShipProcedures from '../data/membership_procedures.pdf';

const benefits = [
  {
    icon: DocumentTextIcon,
    title: '記事掲載の機会',
    desc: '会報・ウェブサイトへの論文・記事掲載',
  },
  {
    icon: MicrophoneIcon,
    title: '講演・発表の場',
    desc: '年次シンポジウムへの登壇機会',
  },
  {
    icon: UsersIcon,
    title: '研究者ネットワーク',
    desc: '全国の研究者・実践者との交流',
  },
];

const Join: React.FC = () => {

  return (
    <section id="join" className="w-full flex flex-col items-center py-16 sm:py-24 px-4 sm:px-6 scroll-mt-20 bg-[#fafaf7]">
      <div className="w-full max-w-5xl">
        {/* セクションヘッダー */}
        <div className="text-center mb-8 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            入会案内
          </h2>
          <p className="text-gray-500 text-base">Membership</p>
        </div>

        {/* ベネフィットグリッド */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 mb-8 sm:mb-12 max-w-3xl mx-auto">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-gray-200/60 text-center hover:shadow-md transition-shadow"
            >
              <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-xl bg-[#1a4a2e]/10 flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <benefit.icon className="w-5 h-5 sm:w-7 sm:h-7 text-[#1a4a2e]" />
              </div>
              <h3 className="font-bold text-xs sm:text-base text-gray-900 mb-1 sm:mb-2">
                {benefit.title}
              </h3>
              <p className="text-[10px] sm:text-sm text-gray-500 leading-tight sm:leading-normal">
                {benefit.desc}
              </p>
            </div>
          ))}
        </div>

        {/* CTA カード */}
        <div className="bg-white rounded-2xl p-6 sm:p-8 lg:p-10 border border-gray-200/60 text-center max-w-2xl mx-auto">
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
            入会ご希望の方はこちら
          </h3>
          <p className="text-sm text-gray-500 mb-6 sm:mb-8">
            入会ご希望の方は、以下より入会手続き・申込書をご確認ください。
          </p>
          <div className="flex flex-col gap-3 sm:flex-row sm:gap-4 justify-center">
            <a
              href={memberShipProcedures}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#1a4a2e] text-white px-5 py-2.5 sm:px-6 sm:py-3 text-sm sm:text-base rounded-full font-semibold hover:bg-[#4a7c59] transition shadow"
            >
              入会手続きについて
            </a>
            <a
              href={memberShipApplication}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border border-[#1a4a2e]/40 text-[#1a4a2e] px-5 py-2.5 sm:px-6 sm:py-3 text-sm sm:text-base rounded-full font-semibold hover:bg-[#1a4a2e]/5 transition"
            >
              <ArrowDownTrayIcon className="h-4 w-4" />
              入会申込書
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Join;
